export default __webpack_public_path__ + "static/media/shrewdblow1.9464c2ca.png";